import { render, staticRenderFns } from "./wechat_guide.vue?vue&type=template&id=8d2f097e&scoped=true&"
import script from "./wechat_guide.vue?vue&type=script&lang=js&"
export * from "./wechat_guide.vue?vue&type=script&lang=js&"
import style0 from "./wechat_guide.vue?vue&type=style&index=0&id=8d2f097e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2f097e",
  null
  
)

export default component.exports